import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import Props from '@/components/app/product/components/best-seller-badge/type';

export default function BestSellerBadge({ icon, title }: Props) {
  return (
    <Container center className='justify-start gap-4 pt-0.5 pr-[18px] pb-4'>
      <XImage src={icon.publicLink} alt={icon.title} width={45} height={50} />
      <Text className='text-[#76767C]' bold size={SIZE_ENUM.SM}>
        {title}
      </Text>
    </Container>
  );
}
